/* eslint-disable @typescript-eslint/no-explicit-any */
import { httpApi } from "api/http.api";
import { AxiosError } from "axios";
import { ShareDesignDetails } from "interfaces/ShareDesign/IShareDesign";

export const saveShareCustomDesign = (body: ShareDesignDetails) => {
  const url = "/rawlingsmylocker/AddOrUpdateShareDesignDetails";
  return httpApi
    .post(url, body)
    .then((response) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

export const getConfigurationDetails = (ids: string) => {
  const url = `/rawlingsmylocker/getconfigurationdetails/${ids}`;
  return httpApi
    .get(url)
    .then((response) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

export const getImage = (imgUrl: string) => {
  const url = encodeURI(imgUrl);
  const formData: any = new FormData();
  formData.append("imgurl", url);
  const endpoint = "rawlingsmylocker/proxyingimage";
  return httpApi
    .post(endpoint, formData)
    .then((response) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

// eslint-disable-next-line
export const sendEmail = (reqBody: any) => {
  const url = "/rawlingsmylocker/ShareDesignDetailsByEmail";
  return httpApi
    .post(url, reqBody)
    .then((response) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};
